export default "__VITE_ASSET__Ck1FmDo2__"